<template>
  <div>
    <Modal :title="title" v-model="modalModel" @on-cancel="modalModelCancel">
      <Form ref="periodicForm" :model="periodicForm" :label-width="100" >
        <FormItem label="定时调度方式" prop="schedule_type">
          <RadioGroup v-model="periodicForm.schedule_type">
            <Radio label="intervals">Interval</Radio>
            <Radio label="crontabs">Crontab</Radio>
          </RadioGroup>
        </FormItem>
        <div v-if="periodicForm.schedule_type === 'intervals'">
          <FormItem label="Every" prop="interval.every">
            <Input v-model="periodicForm.interval.every"/>
          </FormItem>
          <FormItem label="Period" prop="interval.period">
            <Select v-model="periodicForm.interval.period" clearable>
              <Option value="days" key="days">Days</Option>
              <Option value="hours" key="hours">Hours</Option>
              <Option value="minutes" key="minutes">Minutes</Option>
              <Option value="seconds" key="seconds">Seconds</Option>
            </Select>
          </FormItem>
        </div>
        <div v-else>
          <FormItem label="Minute">
            <Input v-model="periodicForm.crontab.minute" :maxlength="60 * 4" />
          </FormItem>
          <FormItem label="Hour">
            <Input v-model="periodicForm.crontab.hour" :maxlength="24 * 4" />
          </FormItem>
          <FormItem label="Day of week">
            <Input v-model="periodicForm.crontab.day_of_week" :maxlength="64" />
          </FormItem>
          <FormItem label="Day of month">
            <Input v-model="periodicForm.crontab.day_of_month" :maxlength="31 * 4"/>
          </FormItem>
          <FormItem label="Month of year">
            <Input v-model="periodicForm.crontab.month_of_year" :maxlength="64" />
          </FormItem>
        </div>
        <FormItem label="启动">
          <i-switch v-model="periodicForm.enabled">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="ok" :loading="submitting">提交</Button>
        <Button @click="modalModel = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { cronTransportEnabledApi, detailCronTransport } from '@/api/troop/troop'

export default {
  name: 'periodic-timer',
  data () {
    return {
      title: '定时器',
      modalModel: false,
      periodicForm: {
        id: '',
        schedule_type: 'intervals',
        interval: {
          every: 1,
          period: ''
        },
        crontab: {
          minute: '*',
          hour: '*',
          day_of_week: '*',
          day_of_month: '*',
          month_of_year: '*'
        },
        enabled: false
      },
      submitting: false
    }
  },
  methods: {
    // 打开Modal
    openModal (id) {
      this.periodicForm.id = id
      detailCronTransport(id).then(res => {
        this.periodicForm.schedule_type = res.data.schedule_type
        if (res.data.periodic_task) {
          if (res.data.schedule_type === 'intervals') {
            this.periodicForm.interval = res.data.periodic_task.interval
          } else {
            this.periodicForm.crontab = res.data.periodic_task.crontab
          }
          this.periodicForm.enabled = res.data.periodic_task.enabled
        }
        this.modalModel = true
      }).catch(res => {
        this.$Notice.error({ title: '获取数据失败' })
      })
    },
    // 提交
    ok () {
      if (this.periodicForm.enabled) {
        if (this.periodicForm.schedule_type === 'intervals') {
          if (this.periodicForm.interval.every === null) {
            this.$Notice.error({ title: '请填写Every！' })
            return
          } else if (!this.periodicForm.interval.period) {
            this.$Notice.error({ title: '请选择Period！' })
            return
          }
        } else {
          if (!this.periodicForm.crontab.minute) {
            this.$Notice.error({ title: '请填写Minute！' })
            return
          } else if (!this.periodicForm.crontab.hour) {
            this.$Notice.error({ title: '请填写Hour！' })
            return
          } else if (!this.periodicForm.crontab.day_of_week) {
            this.$Notice.error({ title: '请填写Day of week！' })
            return
          } else if (!this.periodicForm.crontab.day_of_month) {
            this.$Notice.error({ title: '请填写Day of month！' })
            return
          } else if (!this.periodicForm.crontab.month_of_year) {
            this.$Notice.error({ title: '请填写Month of year！' })
            return
          }
        }
      }
      this.submitting = true
      cronTransportEnabledApi(this.periodicForm).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.modalModel = false
        this.submitting = false
        this.$emit('callbackSuccess')
      }).catch(res => {
        this.submitting = false
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({ title: '操作失败！' })
        }
      })
    },
    // 关闭模态框触发
    modalModelCancel () {
      this.periodicForm = {
        id: '',
        schedule_type: 'intervals',
        interval: {
          every: 1,
          period: ''
        },
        crontab: {
          minute: '*',
          hour: '*',
          day_of_week: '*',
          day_of_month: '*',
          month_of_year: '*'
        },
        enabled: false
      }
    }
  }
}
</script>

<style scoped>

</style>
